



























import { debounceProcess } from "@/helpers/debounce";
import { useInvoiceAP } from "@/hooks";
import { Option } from "@/models/class/option.class";
import { RequestQueryParams } from "@/models/class/request-query-params.class";
import { DataInvoiceAp } from "@/models/interface/invoiceAp.interface";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SelectInvoiceAp extends Vue {
  @Prop({ required: true, type: String, default: "" })
  value!: string;

  @Prop({ required: false, type: Boolean, default: false })
  disabled!: boolean;

  options: Option<DataInvoiceAp>[] = [];
  loading = false;

  created(): void {
    this.onSearch = debounceProcess(this.onSearch);

    this.fetchOptions();
  }

  fetchOptions(params: RequestQueryParams = new RequestQueryParams()): void {
    const { findAll, toOptions } = useInvoiceAP();
    this.loading = true;
    findAll(params)
      .then(({ data }) => {
        this.options = toOptions(data);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onChange(e: string): void {
    this.$emit("input", e);
    this.$emit("change", e);
    this.$emit("update:meta", this.findOption(e));
  }

  onSearch(val = ""): void {
    const { filterBy } = useInvoiceAP();
    const params = new RequestQueryParams();
    params.search = filterBy({ invoiceNumber: val });

    this.fetchOptions(params);
  }

  findOption(value: string): Option<DataInvoiceAp> | undefined {
    return this.options.find(e => value === e.value);
  }
}
